export var CURRENCY_TO_LOCALE = {
  JPY: 'ja-JP',
  USD: 'en-US'
};
export var formatAmount = function formatAmount(amount, options) {
  var currency = options.currency,
      _options$minimumFract = options.minimumFractionDigits,
      minimumFractionDigits = _options$minimumFract === void 0 ? 0 : _options$minimumFract,
      _options$maximumFract = options.maximumFractionDigits,
      maximumFractionDigits = _options$maximumFract === void 0 ? 2 : _options$maximumFract;
  var locale = CURRENCY_TO_LOCALE[currency] || CURRENCY_TO_LOCALE.USD;
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'code',
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits
  });
};
export var getTeamSizeLabel = function getTeamSizeLabel(item) {
  return item.ceiling ? "".concat(item.ceiling, " users") : "".concat(item.floor, "+ users");
};